import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

const TitleMedium = ({
  className,
  ...rest
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h4 className={classNames('display-l-bold', className)} {...rest} />
);

export default TitleMedium;
